import React from 'react';
import Button from './Button';
import './Common.css';

const ErrorMessage = ({ message, onRetry }) => {
  return (
    <div className="error-message">
      <div className="error-message__icon">!</div>
      <div className="error-message__content">
        <p className="error-message__text">{message}</p>
        {onRetry && (
          <Button
            variant="secondary"
            size="small"
            type="button"
            onClick={onRetry}
          >
            Try Again
          </Button>
        )}
      </div>
    </div>
  );
};

export default ErrorMessage;
